import { useRef, useState } from "react";
import { Button, ButtonProps, Menu, MenuItem } from "@mui/material";
import { Translate as TranslateIcon } from "@mui/icons-material";
import { changeLanguage } from "i18next";

import i18n from "i18n";
import { AVAILABLE_LANGUAGES } from "config/languages";

interface Props extends ButtonProps {}

export function LanguageMenu(props: Props) {
  const { ...buttonProps } = props;
  const [open, setOpen] = useState(false);
  const accountButtonRef = useRef<HTMLButtonElement>(null!);
  const currentLanguage = i18n.language;

  function handleMenuItemClick(language: string) {
    changeLanguage(language);
    setOpen(false);
  }

  return render();

  function render() {
    return (
      <>
        <Button
          {...buttonProps}
          onClick={() => setOpen(!open)}
          ref={accountButtonRef}
        >
          <TranslateIcon />
        </Button>
        <Menu
          anchorEl={accountButtonRef.current}
          open={open}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          onClose={() => setOpen(!open)}
        >
          {AVAILABLE_LANGUAGES.map((language) => (
            <MenuItem
              key={language}
              selected={currentLanguage === language}
              onClick={() => handleMenuItemClick(language)}
            >
              {language.toLocaleUpperCase()}
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  }
}
